<template>
  <div class="claim__item" :class="getSlimClass">
    <div v-if="isPassengerSection" class="claim__content">
      <claim-passengers></claim-passengers>
    </div>

    <div v-if="isBankSection" class="claim__content">
      <claim-bank-details></claim-bank-details>
    </div>

    <div v-if="isDocumentSection" class="claim__content">
      <h3 class="claim__item--title title--l">{{ getUiString(['claim_details','details', 'documents','title']) }}</h3>
      <base-flex-message :message="fileUploadHelpText" :folding="false" :opentext="fileUploadHelpOpenText" :closetext="fileUploadHelpCloseText"></base-flex-message>
      <claim-file-documents v-if="isDocumentSection" :renderUpload="false"></claim-file-documents>
    </div>
  </div>
</template>

<script>
import ClaimPassengers from '@/components/person/ClaimPassengers.vue'
import ClaimFileDocuments from '@/components/claims/ClaimFileDocuments.vue'
import ClaimBankDetails from '@/components/claims/ClaimBankDetails.vue'
import { formatDate } from '@/utils/datetime'
import { mapGetters } from 'vuex'

export default {
  name: 'ClaimDetailsTabItem',
  props: {
    detailsSection: {
      type: String,
      required: true
    },
    documentId: {
      type: String,
      default () {
        return ''
      }
    }
  },
  components: {
    ClaimPassengers,
    ClaimFileDocuments,
    ClaimBankDetails
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      claimPassengers: 'claim/claimPassengers',
      claim: 'claim/currentClaim'
    }),
    dateTime () {
      return formatDate(this.claim.TimeStamp, 'datetime')
    },
    isPassengerSection () {
      return this.detailsSection === 'Passengers'
    },
    isDocumentSection () {
      return this.detailsSection === 'Documents'
    },
    isBankSection () {
      return this.detailsSection === 'Bankdetails'
    },
    getSlimClass () {
      return this.isPassengerSection || this.isBankSection ? 'claim__item--slim' : ''
    },
    fileUploadHelpText () {
      return this.getUiString(['claim_details', 'details', 'documents', 'text_no_upload'])
    },
    fileUploadHelpOpenText () {
      return this.getUiString(['claim_details', 'details', 'documents', 'text_no_upload_read_more'])
    },
    fileUploadHelpCloseText () {
      return this.getUiString(['claim_details', 'details', 'documents', 'text_no_upload_read_less'])
    }
  }
}
</script>
